<template>
  <footer class="footer-optimized">
    <div class="footer-container">
      <div class="footer-brand-zone">
        <div class="f-logo-wrap">
          <div class="f-logo">LAIQIU</div>
          <p class="f-slogan">在秋意中，预见未来。</p>
        </div>
        <div class="f-subscribe">
          <p>订阅我们的公众号，获取最新科技动态</p>
          <div class="subscribe-input">
            <!-- <input type="text" placeholder="输入您的邮箱" /> -->
            <input type="text" placeholder="微信搜索“来秋Network" />
            <button>订阅</button>
          </div>
        </div>
      </div>

      <hr class="f-divider" />

      <div class="footer-nav-grid">
        <div class="nav-col">
          <h4>探索社区</h4>
          <ul>
            <li><a href="#">技术沙龙</a></li>
            <li><a href="#">开源项目</a></li>
            <li><a href="#">艺术策展</a></li>
            <li><a href="#">数字实验室</a></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4>开发者支持</h4>
          <ul>
            <li><a href="#">API 文档</a></li>
            <li><a href="#">社区准则</a></li>
            <li><a href="#">Bug 反馈</a></li>
            <li><a href="#">GitHub 仓库</a></li>
          </ul>
        </div>
        <div class="nav-col">
          <h4>品牌故事</h4>
          <ul>
            <li><a href="#">关于我们</a></li>
            <li><a href="#">加入团队</a></li>
            <li><a href="#">合作伙伴</a></li>
            <li><a href="#">媒体资源</a></li>
          </ul>
        </div>
        <div class="nav-col social-col">
          <h4>关注我们</h4>
          <div class="social-icons">
            <div class="icon-box">WeChat</div>
            <div class="icon-box">XiaoChengXu</div>
            <div class="icon-box">Public</div>
          </div>
          <p class="contact-email">官方邮箱：lqaqiu_laiqiu520@163.com</p>
        </div>
      </div>

      <!-- 底部版权 + 备案 优化版 -->
      <div class="footer-bottom">
        <div class="legal-links">
          <router-link to="/privacy">隐私政策</router-link>
          <router-link to="/service">服务协议</router-link>
          <router-link to="/cookie">Cookie 设置</router-link>
        </div>

        <div class="copyright-wrapper">
          <div class="copyright-text">
            © 2026 来秋 - 本站所有资源仅用于学习交流，禁止商用
          </div>
          <div class="footer-record">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=35020302037057" target="_blank" rel="noreferrer">
              <img src="@/assets/备案图标.png" alt="网安备案">
              闽公网安备35020302037057号
            </a>
            <span class="split">|</span>
            <a href="httpsbeian.miit.gov.cn/" target="_blank" rel="noreferrer">
              闽ICP备2026009133号-1
            </a>
          </div>
        </div>

        <div class="back-to-top" @click="scrollToTop">
          BACK TO TOP <span>↑</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<style scoped>
.footer-optimized {
  background-color: #080808;
  padding: 80px 10% 40px;
  position: relative;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
}

.footer-brand-zone {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 50px;
}

.f-logo {
  font-size: 2.5rem;
  font-weight: 900;
  letter-spacing: -1px;
  background: linear-gradient(180deg, #fff 0%, #444 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.f-slogan {
  font-size: 0.9rem;
  opacity: 0.5;
  margin-top: 10px;
}

.f-subscribe p {
  font-size: 0.85rem;
  margin-bottom: 15px;
  text-align: right;
  opacity: 0.8;
}

.subscribe-input {
  display: flex;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 5px;
  border-radius: 4px;
}

.subscribe-input input {
  background: transparent;
  border: none;
  color: #fff;
  padding: 10px 15px;
  outline: none;
  width: 250px;
}

.subscribe-input button {
  background: #fff;
  color: #000;
  border: none;
  padding: 0 20px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.subscribe-input button:hover {
  background: #6d5dfc;
  color: #fff;
}

.f-divider {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 60px;
}

.footer-nav-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  margin-bottom: 80px;
}

.nav-col h4 {
  font-size: 0.9rem;
  margin-bottom: 25px;
  color: #fff;
  letter-spacing: 1px;
}

.nav-col ul {
  list-style: none;
  padding: 0;
}

.nav-col ul li {
  margin-bottom: 12px;
}

.nav-col ul li a {
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  font-size: 0.85rem;
  transition: 0.3s;
}

.nav-col ul li a:hover {
  color: #6d5dfc;
  padding-left: 5px;
}

.social-icons {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.icon-box {
  width: auto;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.7rem;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;
}

.icon-box:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: #fff;
}

.contact-email {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
}

/* ------------------------------ */
/* 🔥 底部布局 优化核心 */
/* ------------------------------ */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.3);
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  flex-wrap: wrap;
  gap: 16px;
}

.copyright-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.copyright-text {
  line-height: 1.4;
}

.footer-record {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1.4;
}

.footer-record img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 4px;
}

.footer-record a {
  color: inherit;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.split {
  margin: 0 4px;
}

.legal-links {
  display: flex;
  gap: 20px;
}

.legal-links span {
  cursor: pointer;
}

.legal-links span:hover {
  color: #fff;
}

.back-to-top {
  cursor: pointer;
  letter-spacing: 2px;
  transition: 0.3s;
  white-space: nowrap;
}

.back-to-top:hover {
  color: #fff;
}

.back-to-top span {
  margin-left: 8px;
  display: inline-block;
  animation: bounce 2s infinite;
}

.legal-links a {
  color: rgba(255, 255, 255, 0.3);
  text-decoration: none;
  margin-right: 20px;
  transition: 0.3s;
}

.legal-links a:hover {
  color: #fff;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-5px);
  }

  60% {
    transform: translateY(-3px);
  }
}

/* ------------------------------ */
/* 移动端适配 */
/* ------------------------------ */
@media (max-width: 992px) {
  .footer-brand-zone {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }

  .footer-nav-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .f-subscribe p {
    text-align: left;
  }
}

@media (max-width: 768px) {
  .footer-bottom {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .legal-links {
    justify-content: center;
  }
}
</style>